const arrayToCsv = array => {
  if (!array) return '';
  return array
    .map(entry => entry.trim())
    .filter(entry => entry !== '')
    .join(', ');
};

export default arrayToCsv;
